import RouteContainer from 'containers/RouteContainer';
import Component from './containers/ComorbidityContainer';

import { editTitle } from 'lib/toolbar';

export const path = `${DOCUMENTS_PATH}/comorbidity`;
export const navigation = { name: 'comorbidity', id: 'comorbidity.title', editTitle };

export default RouteContainer(path, Component);
